import styled from "styled-components";

export const Line = styled.div`
    border-bottom: 1.5px solid white;
    border-color: ${(props) => (props.color)};
`;